import { call, put, takeEvery } from 'redux-saga/effects';
import {
  DeleteTargetedItemGroup,
  ITargetedCatalogGroup,
  targetedCatalogActionCreators,
  TargetedCatalogActionKeys
} from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { deleteGroup } from '../targetedCatalogApi';

function* deleteTargetedItemGroupSaga(action: DeleteTargetedItemGroup) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<ITargetedCatalogGroup[]> = yield call(deleteGroup, action.payload.groupId);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else {
    yield put(targetedCatalogActionCreators.removeItemGroup(action.payload.groupId));
    if (response.value) {
      yield put(targetedCatalogActionCreators.setItemGroups(response.value));
    }
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteTargetedItemGroup() {
  yield takeEvery(TargetedCatalogActionKeys.DELETE_TARGETED_ITEM_GROUP, deleteTargetedItemGroupSaga);
}
